import { gql } from '@apollo/client';

export default gql`
  query PaymentReversalPreview($orderId: ID!, $amount: Int!, $kind: String!) {
    paymentReversalPreview(orderId: $orderId, amount: $amount, kind: $kind) {
      amount
      amountBeforeTax
      blockerCode
      blockerMessage
      eligible
      gateway
      maximumReversibleAmount
      paymentReversalsEnabled
      shippingAmount
      taxAmount
    }
  }
`;
